import React from 'react';
import './current-services.css';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import RadioButton from '../../../ssm-homepage/ssm-components/radio-button/radio-button';
import SSMRadioButton from '../../../ssm-homepage/ssm-components/ssm-radio-button/ssm-radio-button';
import { Desktop, Mobile } from '../../../../app-responsive';

const CurrentServices = (props) => {
  const { currentServicesTitle,
    emailAddressHeading,
    currentServicesOptions,
    currentServicesRadioButtonStatus,
    currentServicesSelectAllRadioButtonStatus,
    onRadioButtonCallBackAction,
    onRadioButtonSelectAllCallBackAction,
    customerEmailAddresses,
    selectAllText,
    selectAllOptions,
  } = props;
  const currentServicesHeading = currentServicesOptions.map(currentServicesOption => (
    <div className="col-md-2 pl-sm-0 hidden-mobile" key={`id-${currentServicesOption.key}`}>
      <a className="label current-services-item-heading-col" target="_blank" rel="noopener noreferrer" href={currentServicesOption.productLink}>
        {currentServicesOption.value}
        <TextWithTooltip
          text={<i className="td-icon icon-help" />}
          textClassName="help-icon-container"
          id={`id-${currentServicesOption.key}-tooltip`}
          toolTipText={currentServicesOption.tooltipText}
        />
      </a>
    </div>
  ));

  const selectAllRadioButtonDesktop = currentServicesOptions.map(currentServicesOption => (
    <div className="col-md-2 pl-sm-0 select-all-radio-buttons hidden-mobile" key={`id-selectAll-${currentServicesOption.key}`}>
      <SSMRadioButton
        radioButtonId={`id-selectAll-${currentServicesOption.key}`}
        radioButtonChecked={currentServicesRadioButtonStatus.length > 0 &&
          currentServicesSelectAllRadioButtonStatus.filter(radioButton =>
            radioButton.id.includes(`id-selectAll-${currentServicesOption.key}`)).length > 0
        }
        radioButtonLabel={selectAllText}
        onRadioButtonCallBackActionWithToggle={onRadioButtonSelectAllCallBackAction}
      />
    </div>
  ));

  const selectAllRadioButtonMobile = selectAllOptions.map(selectAllOption => (
    <div className="col-12 pl-sm-0 select-all-radio-buttons-mobile" key={`id-selectAll-${selectAllOption.key}`}>
      <SSMRadioButton
        radioButtonId={`id-selectAll-${selectAllOption.key}`}
        radioButtonChecked={currentServicesRadioButtonStatus.length > 0 &&
          currentServicesSelectAllRadioButtonStatus.filter(radioButton =>
            radioButton.id.includes(`id-selectAll-${selectAllOption.key}`)).length > 0
        }
        radioButtonLabel={selectAllOption.value}
        onRadioButtonCallBackActionWithToggle={onRadioButtonSelectAllCallBackAction}
      />
    </div>
  ));

  const radioButtonListDesktop = emailAddress => currentServicesOptions.map(currentServicesOption => (
    <div className="col-md-2 pl-sm-0 current-service-details-item" key={`id-${emailAddress}-${currentServicesOption.key}`}>
      <RadioButton
        id={`id-${emailAddress}-${currentServicesOption.key}`}
        iconType="tick"
        checked={currentServicesRadioButtonStatus.length > 0 &&
          currentServicesRadioButtonStatus.filter(radioButton =>
            radioButton.id.includes(`id-${emailAddress}-${currentServicesOption.key}`)).length > 0
        }
        callBackAction={onRadioButtonCallBackAction}
      />
    </div>
  ));

  const emailAddressListDesktopView = customerEmailAddresses.map(emailAddress => (
    <div className="row current-service-details align-items-md-center" key={emailAddress}>
      <div className="col-md-2">
        <span className="email-text current-services-item-heading-col current-service-details-item">{emailAddress}</span>
      </div>
      {radioButtonListDesktop(emailAddress)}
    </div>
  ));

  const radioButtonListMobile = emailAddress => currentServicesOptions.map(currentServicesOption => (
    <div className="col-12 pl-sm-0 radio-mobile" key={`id-${emailAddress}-${currentServicesOption.key}`}>
      <RadioButton
        id={`id-${emailAddress}-${currentServicesOption.key}`}
        iconType="tick"
        checked={currentServicesRadioButtonStatus.length > 0 &&
          currentServicesRadioButtonStatus.filter(radioButton =>
            radioButton.id.includes(`id-${emailAddress}-${currentServicesOption.key}`)).length > 0
        }
        callBackAction={onRadioButtonCallBackAction}
      />
      <span className="radio-text">{currentServicesOption.value}</span>
      <TextWithTooltip
        text={<i className="td-icon icon-help" />}
        textClassName="help-icon-container"
        id={`id-${currentServicesOption.key}-tooltip`}
        toolTipText={currentServicesOption.tooltipText}
      />
    </div>
  ));

  const emailAddressListMobileView = customerEmailAddresses.map(emailAddress => (
    <div className="row current-service-details align-items-md-center" key={emailAddress}>
      <div className="col-md-2">
        <span className="email-text current-services-item-heading-col current-service-details-item">{emailAddress}</span>
      </div>
      {radioButtonListMobile(emailAddress)}
    </div>
  ));

  return (
    <div className="row current-service-section">
      <div className="col-12">
        <div className="row">
          <div className="col-12">
            <h2 id="current-services-heading" className="current-service-heading">{currentServicesTitle}</h2>
          </div>
          <div className="col-md-2 current-services-item-heading-col email-heading hidden-mobile">{emailAddressHeading}</div>
          {currentServicesHeading}
        </div>
        <div className="row">
          <div className="col-md-2 pl-sm-0 hidden-mobile">
            &nbsp;
          </div>
          {selectAllRadioButtonDesktop}
        </div>
        <Desktop>
          {emailAddressListDesktopView}
        </Desktop>
        <Mobile>
          <div className="row">
            {selectAllRadioButtonMobile}
          </div>
          {emailAddressListMobileView}
        </Mobile>
      </div>
    </div>
  );
};

export default CurrentServices;
